/**
 * The one email address a visitor has told this site, shared across every
 * capture moment that wants it -- the design-email utility and the Pro
 * early-access step both read and write here, in either order, so nobody is
 * ever asked to type an email twice in the same browser.
 *
 * Same key EmailDesignModal.tsx has always used (`embroidery_email`),
 * pulled out so a second capture moment can share it without importing a
 * component.
 */
const EMAIL_STORAGE_KEY = "embroidery_email";

export function getStoredEmail(): string {
  return localStorage.getItem(EMAIL_STORAGE_KEY) || "";
}

export function setStoredEmail(email: string): void {
  localStorage.setItem(EMAIL_STORAGE_KEY, email);
}

/** On log out: the next person at this browser shouldn't be offered it. */
export function clearStoredEmail(): void {
  localStorage.removeItem(EMAIL_STORAGE_KEY);
}
